<template>
    <v-app>
        <v-container fluid>
            <v-row v-if="$insertAccess($route.path)">
                <v-col md="3" cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Others
                                Info</v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-form @submit.prevent="submitForm(currentStatus)" ref="" id="">
                                    <v-row class="pa-2">
                                        <v-col cols="12">
                                            <v-autocomplete 
                                                variant="outlined" 
                                                density="compact"
                                                bg-color="grey-lighten-4" 
                                                v-model="workorder_id.value.value"
                                                :items="filteredWorkOrderList" 
                                                :item-title="(item) => `${item.code}`"
                                                item-value="id" 
                                                @update:modelValue="onWorkorderChange"
                                                :error-messages="workorder_id.errorMessage.value" 
                                                autocomplete="off"
                                                clearable>
                                                <template #label>
                                                    Work Order
                                                    <!-- <span class="text-red-accent-4">*</span> -->
                                                </template>
                                            </v-autocomplete>

                                            <v-date-input 
                                                label="Sale Order Date" 
                                                density="compact" 
                                                prepend-icon=""
                                                prepend-inner-icon="mdi-calendar" 
                                                variant="outlined"
                                                bg-color="grey-lighten-4" 
                                                v-model="sale_order_date.value.value"
                                                :error-messages="sale_order_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable>
                                            </v-date-input>

                                            <v-autocomplete 
                                                variant="outlined" 
                                                density="compact"
                                                bg-color="grey-lighten-4" 
                                                v-model="order_category.value.value"
                                                :items="[{ name: 'general', display_text: 'General' }, { name: 'production', display_text: 'Production' }]"
                                                :item-title="(item) => `${item.display_text}`" 
                                                item-value="name"
                                                :error-messages="order_category.errorMessage.value" 
                                                autocomplete="off"
                                                clearable
                                                >
                                                <template #label>
                                                    Order Category
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-autocomplete 
                                                variant="outlined" 
                                                density="compact"
                                                bg-color="grey-lighten-4" 
                                                v-model="customer_id.value.value"
                                                :items="getCustomerMapList"
                                                :item-title="(item) => item ? `${item.customer.company_name ? item.customer.company_name : item.customer.company_owner_name ? item.customer.company_owner_name : ''} - ${item.customer.code}` : ''"
                                                item-value="customer_id"
                                                :error-messages="customer_id.errorMessage.value"
                                                autocomplete="off" 
                                                clearable
                                                >
                                                <template #label>
                                                    Customer Name
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-date-input 
                                                label="Shipping Date" 
                                                density="compact"
                                                prepend-icon="" 
                                                prepend-inner-icon="mdi-calendar" 
                                                variant="outlined"
                                                bg-color="grey-lighten-4" 
                                                v-model="shipping_date.value.value"
                                                :error-messages="shipping_date.errorMessage.value" 
                                                autocomplete="off"
                                                clearable
                                                >
                                            </v-date-input>

                                            <v-text-field 
                                                label="Shipping / Delivery Address" 
                                                density="compact"
                                                variant="outlined" 
                                                bg-color="grey-lighten-4"
                                                v-model="delivery_address.value.value"
                                                :error-messages="delivery_address.errorMessage.value" 
                                                autocomplete="off"
                                                clearable>
                                            </v-text-field>

                                            <v-text-field 
                                                label="Ref No" 
                                                density="compact"
                                                variant="outlined" 
                                                bg-color="grey-lighten-4"
                                                v-model="ref_no.value.value" 
                                                :error-messages="ref_no.errorMessage.value"
                                                autocomplete="off" 
                                                clearable>
                                            </v-text-field>

                                            <v-textarea 
                                                label="Due Payment Terms (Days)" 
                                                variant="outlined"
                                                density="compact" 
                                                bg-color="grey-lighten-4" 
                                                rows="3"
                                                v-model="payment_terms.value.value"
                                                :error-messages="payment_terms.errorMessage.value" 
                                                autocomplete="off"
                                                clearable>
                                            </v-textarea>

                                            <v-date-input 
                                                label="Approximate Devliery Date" 
                                                density="compact"
                                                prepend-icon="" 
                                                prepend-inner-icon="mdi-calendar" 
                                                variant="outlined"
                                                bg-color="grey-lighten-4" 
                                                v-model="approximate_delivery_date.value.value"
                                                :error-messages="approximate_delivery_date.errorMessage.value" 
                                                autocomplete="off"
                                                clearable
                                                >
                                            </v-date-input>

                                            <v-text-field 
                                                label="Sale Order By" 
                                                density="compact" 
                                                variant="outlined" 
                                                bg-color="grey-lighten-4"
                                                v-model="saleOrder_by.value.value"
                                                :error-messages="saleOrder_by.errorMessage.value" 
                                                autocomplete="off"
                                                :disabled="true" clearable>
                                            </v-text-field>

                                            <v-text-field 
                                                label="Sale Order By Mobile" 
                                                density="compact" 
                                                variant="outlined" 
                                                bg-color="grey-lighten-4"
                                                v-model="saleOrder_by_mobile.value.value"
                                                :error-messages="saleOrder_by.errorMessage.value" 
                                                autocomplete="off"
                                                :disabled="true" 
                                                clearable>
                                            </v-text-field>

                                            <v-text-field 
                                                label="Sale Order By Email" 
                                                density="compact" 
                                                variant="outlined" 
                                                bg-color="grey-lighten-4"
                                                v-model="saleOrder_by_email.value.value"
                                                :error-messages="saleOrder_by_email.errorMessage.value" 
                                                :disabled="true"
                                                autocomplete="off" 
                                                clearable>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>

                <v-col md="9" cols="12">
                    <v-expansion-panels v-model="panel2">
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Item
                                Info</v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-form @submit.prevent="submitForm(currentStatus)" ref="" id="">
                                    <v-row class="pt-2 justify-center">
                                        <v-col cols="8">
                                            <v-autocomplete 
                                                label="Search Product Name" 
                                                variant="outlined"
                                                density="compact" 
                                                bg-color="grey-lighten-4"
                                                v-model="product_id.value.value"
                                                :items="getProductMapList"
                                                :item-title="(item) => `${item.product.code}-${item.product.name}` ?? 'N/A'" 
                                                item-value="product_id"
                                                :error-messages="product_id.errorMessage.value"
                                                @update:model-value="addCart" 
                                                @keydown.enter="addCart"
                                                autocomplete="off" 
                                                clearable>
                                            </v-autocomplete>

                                            <input v-model="sale_order_master_id.value.value" type="hidden" />
                                        </v-col>

                                        <!-- <v-col cols="1">
                                            <v-btn class="bg-primary" @click="addCart">ADD</v-btn>
                                        </v-col> -->
                                    </v-row>

                                    <!-- Cart Table -->
                                    <v-row class="pt-0">
                                        <v-col cols="12">
                                            <!-- <v-table density="compact" :loading="loading" fixed-header class="table-dotted-border-bottom" style="height:40vh; overflow-y: scroll;"> -->
                                            <v-table density="compact" :loading="loading" fixed-header
                                                class="table-dotted-border-bottom">
                                                <!-- style="height:40vh; overflow-y: scroll;" -->
                                                <thead>
                                                    <tr>
                                                        <th class="text-center" style="width: 5%">SL</th>

                                                        <th class="text-left" style="width: 25%">
                                                            Product Name
                                                        </th>

                                                        <th class="text-center" style="width: 10%">Code</th>

                                                        <th class="text-center" style="width: 10%">Unit</th>

                                                        <th class="text-left" style="width: 10%">
                                                            Quantity
                                                        </th>

                                                        <th class="text-left" style="width: 15%">
                                                            Price
                                                        </th>

                                                        <th class="text-center" style="width: 15%">
                                                            Amount
                                                        </th>


                                                        <th class="text-right" style="width: 5%">Action</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr v-for="(item, index) in cart" v-if="cart.length > 0"
                                                        :key="index">
                                                        <td class="text-center py-1">{{ index + 1 }}</td>

                                                        <td class="text-left py-1" style="white-space: normal">
                                                            {{ item.product_name }}
                                                        </td>

                                                        <td class="text-left py-1" style="white-space: normal">
                                                            {{ item.product_code }}
                                                        </td>

                                                        <td class="text-center py-1">
                                                            {{ item.unit_name }}
                                                        </td>

                                                        <td class="text-left py-2">
                                                            <v-text-field 
                                                                :reverse="false" 
                                                                controlVariant="stacked"
                                                                style="width: 80px" 
                                                                label="" :hideInput="false"
                                                                :inset="false" 
                                                                :min="1" 
                                                                type="number" 
                                                                density="compact"
                                                                variant="outlined" 
                                                                bg-color="grey-lighten-4"
                                                                v-model="item.qty" 
                                                                hide-details 
                                                                :error="item.qty < 1"
                                                                :error-messages="item.qty < 1 ? 'Quantity must be greater than 0' : ''"
                                                                @update:model-value="item.total = item.qty * item.sale_rate"
                                                                @blur="item.total = item.qty * item.sale_rate"
                                                                >
                                                            </v-text-field>
                                                        </td>

                                                        <td class="text-left py-2">
                                                            <v-text-field 
                                                                :reverse="false" 
                                                                controlVariant="stacked"
                                                                style="width: 90px" 
                                                                label="" :hideInput="false"
                                                                :inset="false" 
                                                                :min="1" 
                                                                type="number" 
                                                                density="compact"
                                                                variant="outlined" 
                                                                bg-color="grey-lighten-4"
                                                                v-model="item.sale_rate" 
                                                                hide-details 
                                                                :error="item.sale_rate < 1"
                                                                :error-messages="item.sale_rate < 1 ? 'Quantity must be greater than 0' : ''"
                                                                @update:model-value="item.total = item.qty * item.sale_rate"
                                                                @blur="item.total = item.qty * item.sale_rate"
                                                                >
                                                            </v-text-field>
                                                        </td>

                                                        <td class="text-center py-1">
                                                            {{ this.$numberFormat(item.total) }}
                                                        </td>

                                                        <td class="text-center py-1">
                                                            <v-icon size="small" color="red" class="delete-button"
                                                                @click="removeFromCart(index)">
                                                                mdi-delete
                                                            </v-icon>
                                                        </td>
                                                    </tr>

                                                    <tr v-else-if="loading == true">
                                                        <td colspan="6" class="text-center">
                                                            <v-skeleton-loader type="heading" :loading="loading" />
                                                        </td>
                                                    </tr>

                                                    <tr v-else>
                                                        <td colspan="6" class="text-center text-red">
                                                            You have no item
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                <!-- <tfoot v-if="cart.length > 0"> -->
                                                <tfoot>
                                                    <tr>
                                                        <th colspan="3"
                                                            class="bg-grey-lighten-1 text-right text-uppercase font-weight-bold py-1">
                                                            Sub Total
                                                        </th>

                                                        <th colspan="3" class="bg-grey-lighten-1"></th>

                                                        <th class="bg-grey-lighten-1 text-center font-weight-bold py-1">
                                                            {{ this.$numberFormat(subTotal) }}
                                                        </th>

                                                        <th colspan="2" class="bg-grey-lighten-1"></th>

                                                    </tr>

                                                    <tr>
                                                        <td colspan="3" class="text-right">
                                                            Discount (10 or 10%)
                                                        </td>

                                                        <td></td>
                                                        <td></td>

                                                        <td colspan="1" class="text-right py-1">
                                                            <v-text-field 
                                                                v-model="discount_value.value.value"
                                                                density="compact" 
                                                                label="%" 
                                                                hide-details 
                                                                dense
                                                                autocomplete="off" 
                                                                variant="outlined" 
                                                            />
                                                        </td>

                                                        <td class="text-center">
                                                            {{ this.$numberFormat(discountAmount) }}
                                                        </td>

                                                        <td class="text-center py-1"></td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="3" class="text-right py-1">
                                                            Tax (10 or 10%)
                                                        </td>

                                                        <td></td>

                                                        <td colspan="1" class="text-right py-1">
                                                            <v-select 
                                                                v-model="taxType"
                                                                density="compact"
                                                                variant="outlined" 
                                                                :items="includeOrExclude"
                                                                item-title="label" 
                                                                item-value="value" 
                                                                hide-details
                                                                style="width: 115px">
                                                            </v-select>
                                                        </td>

                                                        <td colspan="1" class="text-right py-1">
                                                            <v-text-field v-model="tax_value.value.value"
                                                                density="compact" label="%" hide-details dense
                                                                autocomplete="off" variant="outlined" />
                                                        </td>

                                                        <td class="text-center">
                                                            {{ this.$numberFormat(taxAmount) }}
                                                        </td>

                                                        <td class="text-center py-1"></td>
                                                    </tr>

                                                    <tr>
                                                        <td colspan="3" class="text-right py-1">
                                                            Vat (10 or 10%)
                                                        </td>
                                                        <td></td>
                                                        <td colspan="1" class="text-right py-1">
                                                            <v-select 
                                                                v-model="vatType" 
                                                                density="compact"
                                                                variant="outlined" 
                                                                :items="includeOrExclude"
                                                                item-title="label" 
                                                                item-value="value" 
                                                                hide-details
                                                                style="max-width: 115px">
                                                            </v-select>
                                                        </td>

                                                        <td colspan="1" class="text-right py-1">
                                                            <v-text-field 
                                                                v-model="vat_value.value.value"
                                                                density="compact" 
                                                                label="%" hide-details dense
                                                                autocomplete="off" 
                                                                variant="outlined" 
                                                            />
                                                        </td>

                                                        <td class="text-center">
                                                            {{ this.$numberFormat(vatAmount) }}
                                                        </td>
                                                        <td></td>
                                                    </tr>

                                                    <tr>
                                                        <th colspan="3"
                                                            class="bg-grey-lighten-1 text-right text-uppercase font-weight-bold py-1">
                                                            Grand Total
                                                        </th>
                                                        <th colspan="3" class="bg-grey-lighten-1 text-right py-1"></th>
                                                        <th class="bg-grey-lighten-1 text-center font-weight-bold py-1">
                                                            {{ this.$numberFormat(grandTotal) }}
                                                        </th>
                                                        <th class="bg-grey-lighten-1"></th>
                                                    </tr>
                                                </tfoot>
                                            </v-table>
                                        </v-col>
                                    </v-row>
                                    <v-divider></v-divider>
                                    <v-row class="pt-0">
                                        <v-col cols="6">
                                            <v-card class="mt-0 elevation-0 rounded-0">
                                                <v-card-title
                                                    class="d-flex align-center py-2 px-4 bg-blue-grey-lighten-5"
                                                    style="font-size: 1.1rem;">
                                                    <span class="">Payment</span>
                                                </v-card-title>
                                                <v-divider></v-divider>
                                                <v-card-text>
                                                    <v-row>
                                                        <v-col cols="5" sm="5" md="5">
                                                            Payment Method
                                                        </v-col>
                                                        <v-col cols="7" sm="7" md="7">
                                                            <v-select 
                                                                v-model="payment_method.value.value" 
                                                                :items="paymentTypes"
                                                                item-title="label" 
                                                                item-value="value" 
                                                                density="compact"
                                                                variant="outlined" 
                                                                autocomplete="off">
                                                            </v-select>
                                                        </v-col>
                                                        <v-col cols="5" sm="5" md="5">
                                                            Payment Head
                                                        </v-col>
                                                        <v-col cols="7" sm="7" md="7">
                                                            <v-autocomplete
                                                                v-model="payment_acc_account_head_id.value.value"
                                                                :items="getPaymentAccountHeadList"
                                                                :item-title="(item) => `${item.name ?? 'Select'}`"
                                                                item-value="id"
                                                                variant="outlined"
                                                                density="compact"
                                                                :loading="accountHeadingLoading"
                                                                clearable
                                                            ></v-autocomplete>
                                                        </v-col>
                                                        <v-col v-if="payment_method.value.value === 'bank'" cols="5" sm="5" md="5">
                                                            Cheque No
                                                        </v-col>
                                                        <v-col v-if="payment_method.value.value === 'bank'" cols="7" sm="7" md="7">
                                                            <v-text-field 
                                                                density="compact"
                                                                v-model="cheque_no.value.value" 
                                                                variant="outlined" 
                                                                hide-details
                                                                autocomplete="off" />
                                                            </v-col>
                                                        <v-col v-if="payment_method.value.value === 'bank'" cols="5" sm="5" md="5">
                                                            Cheque Date
                                                        </v-col>
                                                        <v-col v-if="payment_method.value.value === 'bank'" cols="7" sm="7" md="7">
                                                            <v-date-input 
                                                            density="compact"
                                                            prepend-icon="" 
                                                            prepend-inner-icon="mdi-calendar"
                                                            v-model="cheque_date.value.value" 
                                                            variant="outlined"
                                                            hide-details 
                                                            autocomplete="off"
                                                            ></v-date-input>
                                                        </v-col>
                                                        <v-col v-if="payment_method.value.value === 'bank'" cols="5" sm="5" md="5">
                                                            Bank Name
                                                        </v-col>
                                                        <v-col v-if="payment_method.value.value === 'bank'" cols="7" sm="7" md="7">
                                                            <v-text-field 
                                                                v-model="issuing_bank_name.value.value" 
                                                                density="compact"
                                                                variant="outlined" 
                                                                hide-details 
                                                                autocomplete="off" 
                                                            />
                                                        </v-col>
                                                        <v-col v-if="payment_method.value.value === 'bank'" cols="5" sm="5" md="5">
                                                            Branch Name
                                                        </v-col>
                                                        <v-col v-if="payment_method.value.value === 'bank'" cols="7" sm="7" md="7">
                                                            <v-text-field 
                                                                v-model="issuing_branch_name.value.value" 
                                                                density="compact"
                                                                variant="outlined" 
                                                                hide-details 
                                                                autocomplete="off" 
                                                            />
                                                        </v-col>
                                                        <v-col v-if="payment_method.value.value === 'bank'" cols="5" sm="5" md="5">
                                                            Account No
                                                        </v-col>
                                                        <v-col v-if="payment_method.value.value === 'bank'" cols="7" sm="7" md="7">
                                                            <v-text-field 
                                                                v-model="issuing_bank_account_no.value.value" 
                                                                density="compact"
                                                                variant="outlined" 
                                                                hide-details 
                                                                autocomplete="off" 
                                                            />
                                                        </v-col>
                                                        <v-col v-if="payment_method.value.value === 'mobile'" cols="5" sm="5" md="5">
                                                            Provider
                                                        </v-col>
                                                        <v-col v-if="payment_method.value.value === 'mobile'" cols="7" sm="7" md="7">
                                                            <v-autocomplete 
                                                                v-model="mobileProvider"
                                                                :items="mobileProviders" 
                                                                item-title="label"
                                                                item-value="value" 
                                                                density="compact" 
                                                                variant="outlined"
                                                                hide-details 
                                                                autocomplete="off"
                                                            ></v-autocomplete>
                                                        </v-col>

                                                        <v-col v-if="payment_method.value.value === 'mobile'" cols="5" sm="5" md="5">
                                                            Transaction ID
                                                        </v-col>

                                                        <v-col v-if="payment_method.value.value === 'mobile'" cols="7" sm="7" md="7">
                                                            <v-text-field v-model="transactionId" density="compact"
                                                                variant="outlined" hide-details autocomplete="off" />
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-card class="mt-0 elevation-0 rounded-0">
                                                <!-- <v-card-title class="d-flex align-center py-2 px-4 bg-blue-grey-lighten-5" style="font-size: 1.1rem;">
                                <span class="">Payment</span>
                            </v-card-title> -->
                                                <v-card-text>
                                                    <v-row>
                                                        <v-col cols="6" sm="6" md="6">
                                                            Advance Payment
                                                        </v-col>
                                                        <v-col cols="6" sm="6" md="6">
                                                            <v-text-field v-model="paid.value.value" 
                                                                density="compact"
                                                                label="Payment Received" 
                                                                type="number" 
                                                                hide-details
                                                                variant="outlined"
                                                                @update:model-value="onChangePayReceived" 
                                                            />
                                                        </v-col>
                                                        <v-col cols="6" sm="6" md="6">
                                                            Previous Due
                                                        </v-col>
                                                        <v-col cols="6" sm="6" md="6">
                                                            <v-text-field 
                                                                v-model="previous_due.value.value" 
                                                                density="compact"
                                                                label="Previous Due" 
                                                                type="number" 
                                                                hide-details
                                                                readonly
                                                                variant="outlined" 
                                                            />
                                                        </v-col>
                                                        <v-col cols="6" sm="6" md="6">
                                                            Total Due
                                                        </v-col>
                                                        <v-col cols="6" sm="6" md="6">
                                                            <v-text-field 
                                                                v-model="due.value.value" 
                                                                density="compact"
                                                                label="Total Due" 
                                                                type="number" 
                                                                hide-details
                                                                readonly
                                                                variant="outlined" />
                                                        </v-col>
                                                        <v-col cols="6" sm="6" md="6">
                                                            Next Payment Date
                                                        </v-col>
                                                        <v-col cols="6" sm="6" md="6">
                                                            <v-date-input 
                                                                label="Next Payment Date" 
                                                                density="compact" 
                                                                prepend-icon=""
                                                                prepend-inner-icon="mdi-calendar" 
                                                                variant="outlined"
                                                                v-model="next_payment_date.value.value"
                                                                :error-messages="next_payment_date.errorMessage.value"
                                                                autocomplete="off"
                                                                clearable>
                                                            </v-date-input>
                                                        </v-col>
                                                        <v-col cols="6" sm="6" md="6">
                                                            Next Payment Approx. Amount
                                                        </v-col>
                                                        <v-col cols="6" sm="6" md="6">
                                                            <v-text-field v-model="next_payment_amount.value.value" density="compact"
                                                                type="number" hide-details variant="outlined" />
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                    </v-row>

                                    <!-- Close Cart Table -->

                                    <v-divider></v-divider>

                                    <v-card-actions>
                                        <v-row class="pt-2">
                                            <v-col cols="8">
                                                <v-textarea label="Description" density="compact" variant="outlined"
                                                    bg-color="grey-lighten-4" v-model="remarks.value.value"
                                                    :error-messages="remarks.errorMessage.value" autocomplete="off"
                                                    rows="3" clearable></v-textarea>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-layout class="justify-end">
                                                    <v-btn class="bg-grey-darken-1 me-2" variant="flat"
                                                        @click="submitForm(0)">DRAFT</v-btn>
                                                    <v-btn class="bg-primary" variant="flat"
                                                        @click="submitForm(1)">POST</v-btn>
                                                </v-layout>
                                            </v-col>
                                        </v-row>
                                    </v-card-actions>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { nextTick, getCurrentInstance, ref } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import { useRouter } from "vue-router";
export default {
    components: {},
    data: () => ({
        panel: [0],
        panel2: [0],
        loading: false,
        errorMessages: "",
        isEntryMode: true,
        visible: false,
        search: "",
        selectedImage: null,
        photo_imageFile: "",
        preview: "/src/assets/no_preview.png",
        cart: [],
        accountHeadingLoading:false,
        vatType: 'include',
        taxType: 'include',
        includeOrExclude: [
            { value: 'include', label: "Include" },
            { value: 'exclude', label: "Exclude" },
        ],

        bankName: null,
        accountNo: "",
        mobileProvider: null,
        transactionId: "",
        paymentTypes: [
            { label: "Cash", value: "cash" },
            { label: "Bank", value: "bank" },
            { label: "Mobile Banking", value: "mobile" }
        ],
        banks: [
            { label: "Al Rajhi Bank", value: "alrajhi" },
            { label: "NCB", value: "ncb" },
            { label: "Riyad Bank", value: "riyad" }
        ],
        mobileProviders: [
            { label: "Bkash", value: "bkash" },
            { label: "Nagad", value: "nagad" },
            { label: "Rocket", value: "rocket" }
        ]
    }),
    watch: {
        grandTotal(newVal) {
            this.due.value.value = (parseFloat(newVal || 0) + parseFloat(this.previous_due.value.value)) - parseFloat(this.paid.value.value);
        },
        "payment_method.value.value":{
            handler(newVal){
                if (newVal) {
                    this.accountHeadingLoading = true;
                    this.$store.dispatch("getPaymentAccountHeadList", {
                        type: newVal,
                    }).then((res) => {
                        this.accountHeadingLoading = false;
                    });
                    this.payment_acc_account_head_id.value.value = null;
                }
            }
        }
    },
    created() {
        if (this.$store.getters.getCustomerMapList.length === 0) {
            this.$store.dispatch("getCustomerMapList");
        }
        if (this.$store.getters.getProductMapList.length === 0) {
            this.$store.dispatch("getProductMapList");
        }
        // if (this.$store.getters.getSalesWorkOrderList.length === 0) {
        this.$store.dispatch("getSalesWorkOrderList", { lock: 0 });
        // }
    },
    computed: {
        subTotal() {
            return this.cart.reduce((sum, item) => +sum + +item.total, 0);
        },

        discountAmount() {
            if (!this.discount_value?.value.value) {
                this.discount_value.value.value = 0;
                this.discount_method.value.value = 'flat';
                this.discount_type.value.value = null;
                return 0;
            } 

            const val = this.discount_value.value.value.toString().trim();
            if (val.endsWith("%")) {
                this.discount_method.value.value = 'percent';
                this.discount_type.value.value = 1;
                const percentage = parseFloat(val.replace("%", ""));
                return (this.subTotal * percentage) / 100 || 0;
            }
            this.discount_method.value.value = 'flat';
            this.discount_type.value.value = 2;
            return parseFloat(val) || 0;
        },
        subtotalAfterDiscount() {
            return this.subTotal - this.discountAmount;
        },
        taxAmount() {
            if (!this.tax_value?.value.value) {
                this.tax_value.value.value = 0;
                this.tax_method.value.value = 'flat';
                return 0;
            } 

            const val = this.tax_value.value.value.toString().trim();
            if (val.endsWith("%")) {
                this.tax_method.value.value = 'percent';
                const percentage = parseFloat(val.replace("%", ""));
                return (this.subtotalAfterDiscount * percentage) / 100 || 0;
            }
            return parseFloat(val) || 0;
        },
        vatAmount() {
            if (!this.vat_value.value.value) {
                this.vat_value.value.value = 0;
                this.vat_method.value.value = 'flat';
                return 0;
            } 

            const val = this.vat_value.value.value.toString().trim();
            if (val.endsWith("%")) {
                this.vat_method.value.value = 'percent';
                const percentage = parseFloat(val.replace("%", ""));
                return (this.subtotalAfterDiscount * percentage) / 100 || 0;
            }
            return parseFloat(val) || 0;
        },
        grandTotal() {
            const discount = this.discountAmount;
            const vat = this.vatType === 'include' ? this.vatAmount : 0;
            const tax = this.taxType === 'include' ? this.taxAmount : 0;
            return this.subTotal + vat + tax - discount;
        },

        branchId() {
            return this.$store.getters.getAuthUser.branch_id || null;
        },
        
        getPaymentAccountHeadList() {
            return this.$store.getters.getPaymentAccountHeadList;
        },

        getProductMapList() {
            let products = this.$store.getters.getProductMapList;
            return products.filter(
                (item) => item.branch_id == this.branchId && item.status == 1
            );
        },
        getCustomerMapList() {
            return this.$store.getters.getCustomerMapList;
        },
        filteredWorkOrderList() {
            const workorders = this.$store.getters.getSalesWorkOrderList || [];
            return workorders.filter(
                (item) => item.branch_id == this.branchId && item.status == 1
            );
        },
    },
    methods: {
        addCart() {
            let cartInd = this.cart.findIndex(
                (p) => p.product_id == this.product_id.value.value
            );
            if (this.product_id.value.value == null) {
                toast.error("Please select a Product");
                this.cartReset();
                return false;
            }
            if (cartInd > -1) {
                toast.error("Product already added in cart");
                this.cartReset();
                return false;
            }

            let product = this.getProductMapList.find(
                (item) => item.product_id == this.product_id.value.value
            );
            product = product.product;

            let item = {
                product_id: this.product_id.value.value,
                product_name: product.name,
                product_code: product.code,
                qty: 1,
                unit_id: product.unit_id,
                unit_name: product.unit.name,
                purchase_rate: product.purchase_rate,
                sale_rate: product.sale_rate,
                total: product.sale_rate,
            };

            this.cart.push(item);
            this.$nextTick(() => {
                this.cartReset();
            });
        },
        removeFromCart(index) {
            if (confirm("Are You Sure?")) {
                this.cart.splice(index, 1);
            }
        },
        cartReset() {
            // this.product_id.setValue(null);
            // this.product_id = null;
            console.log(this.product_id.value)
        },
        onChangePayReceived() {
            this.due.value.value = (parseFloat(this.grandTotal || 0) + parseFloat(this.previous_due.value.value)) - parseFloat(this.paid.value.value);
        },
        async onWorkorderChange(selectedId) {

            if (!selectedId) {
                this.order_category.value.value = null;
                this.cart = [];
                return;
            }

            try {
                const data = await this.$store.dispatch("getSalesWorkOrderById", selectedId);
                const workOrder = data.data; 
                this.customer_id.value.value = workOrder.customer?.id
                this.ref_no.value.value = workOrder.proposal.ref_no || "";

                this.cart = [];
                (workOrder.proposal.details || []).forEach((item) => {
                    this.cart.push({
                        product_id: item.product_id,
                        product_name: item.product?.name || "",
                        product_code: item.product?.code || "",
                        qty: item.qty,
                        unit_id: item.product?.unit_id || "",
                        unit_name: item.product?.unit?.name || "",
                        purchase_rate: item.purchase_rate,
                        sale_rate: item.sale_rate,
                        total: item.qty * item.sale_rate,
                    });
                });
                this.$store.commit("UNSET_LOADING");
            } catch (error) {
                console.error("Failed to load requisition data:", error);
            }
        },
    },
    setup() {
        const { proxy } = getCurrentInstance();
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                sale_order_date: yup.date().required().label("Purchase Order Date"),
                shipping_date: yup.date().nullable().label("Shipping Date"),
                approximate_delivery_date: yup.date().nullable().label("Approximate Delivery Date"),
                delivery_address: yup.string().nullable().label('Address'),
                ref_no: yup.string().nullable().label('ref no'),
                order_category: yup.string().required().label("Order Category"),
                workorder_id: yup.number().positive().integer().nullable().label("Work Order"),
                customer_id: yup.number().positive().integer().required().label("Customer Name"),
            }),
        });

        const product_id = useField("product_id");
        const sale_order_master_id = useField("sale_order_master_id");
        const employee_id = useField("employee_id");
        const order_category = useField("order_category");
        const workorder_id = useField("workorder_id");
        const customer_id = useField("customer_id");
        const shipping_date = useField("shipping_date");
        const approximate_delivery_date = useField("approximate_delivery_date");
        const delivery_address = useField("delivery_address");
        const ref_no = useField("ref_no");
        const payment_terms = useField("payment_terms");

        const discount_value = useField("discount_value");
        const discount_method = useField("discount_method");
        const discount_type = useField("discount_type");
        const discount_amount = useField("discount_amount");
        const tax_amount = useField("tax_amount");
        const tax_value = useField("tax_value");
        const tax_type = useField("tax_type");
        const tax_method = useField("tax_method");
        const vat_amount = useField("vat_amount");
        const vat_value = useField("vat_value");
        const vat_type = useField("vat_type");
        const vat_method = useField("vat_method");

        const status = useField("status");

        const payment_method = useField("payment_method");
        const payment_acc_account_head_id = useField("payment_acc_account_head_id");
        const cheque_no = useField("cheque_no");
        const cheque_date = useField("cheque_date");
        const issuing_bank_name = useField("issuing_bank_name");
        const issuing_branch_name = useField("issuing_branch_name");
        const issuing_bank_account_no = useField("issuing_bank_account_no");

        const sale_order_date = useField("sale_order_date");
        const saleOrder_by = useField("saleOrder_by");
        const saleOrder_by_mobile = useField("saleOrder_by_mobile");
        const saleOrder_by_email = useField("saleOrder_by_email");
        const total = useField("total");
        const paid = useField('paid');
        const previous_due = useField('previous_due');
        const due = useField('due');
        const next_payment_date = useField('next_payment_date');
        const next_payment_amount = useField('next_payment_amount');
        const remarks = useField("remarks");
        const errorMessages = ref("");
        const cart = ref([]);
        const loading = ref("");
        const buttonText = ref("");
        buttonText.value = "Save";
        const store = useStore();
        const router = useRouter();

        const currentStatus = ref(0);

        const submitForm = (status) => {
            currentStatus.value = status;
            submit();
        };

        const submit = handleSubmit((values) => {
            values.status = currentStatus.value;
            values.sub_total = proxy.subTotal;

            values.discount_amount = proxy.discountAmount;
            values.discount_type = discount_type.value.value;
            
            values.tax_amount = proxy.taxAmount;
            values.tax_type = proxy.taxType;

            values.vat_amount = proxy.vatAmount;
            values.vat_type = proxy.vatType;

            values.total = proxy.grandTotal;

            values.cart = cart.value;
            values.sale_order_date = formattedDate(sale_order_date.value.value);
            values.shipping_date = formattedDate(shipping_date.value.value);
            values.approximate_delivery_date = formattedDate(approximate_delivery_date.value.value);
            values.delivery_address = delivery_address.value.value;
            values.ref_no = ref_no.value.value;
            values.paid = paid.value.value;
            values.previous_due = previous_due.value.value;
            values.due = due.value.value;
            values.next_payment_date = formattedDate(next_payment_date.value.value);
            values.next_payment_amount = next_payment_amount.value.value;
            store.dispatch("saveUpdateSaleOrder", values)
                .then((response) => {
                    resetForm();
                    buttonText.value = "Save";
                    cart.value = [];
                    toast.success(response.data.message, {
                        timeout: 3000,
                    });
                    setTimeout(() => {
                        router.push({ name: "sale-order-record" });
                    }, 2000);
                })
                .catch((error) => {
                    if (error.response && error.response.data && error.response.data.errors) {
                        const errors = error.response.data.errors;
                        const messages = Object.values(errors).flat().join('\n');
                        toast.error(messages);
                    } else {
                        toast.error(error.response?.data?.message || 'Something went wrong');
                    }
                });
        });

        return {
            submitForm,
            submit,
            product_id,
            sale_order_date,
            shipping_date,
            approximate_delivery_date,
            delivery_address,
            ref_no,
            payment_terms,
            remarks,
            
            payment_method,
            payment_acc_account_head_id,
            cheque_no,
            cheque_date,
            issuing_bank_name,
            issuing_branch_name,
            issuing_bank_account_no,

            discount_value,
            discount_method,
            discount_amount,
            discount_type,
            tax_amount,
            tax_value,
            tax_method,
            tax_type,
            vat_amount,
            vat_value,
            vat_method,
            vat_type,
            status,
            total,
            paid,
            previous_due,
            due,
            next_payment_date,
            next_payment_amount,
            cart,
            saleOrder_by,
            saleOrder_by_mobile,
            saleOrder_by_email,
            errorMessages,
            employee_id,
            order_category,
            workorder_id,
            customer_id,
            sale_order_master_id,
            buttonText,
            loading,
        };
    },

    mounted() {
        this.employee_id.value.value = "";
        let user = this.$store.getters.getAuthUser;
        this.saleOrder_by.value.value = user.full_name;
        this.saleOrder_by_mobile.value.value = user.mobile;
        this.saleOrder_by_email.value.value = user.email;
        
        const workorderId = this.$route.query.workorder_id;
       
        if(workorderId) {
            this.$watch(() => this.filteredWorkOrderList,
                (list) => {
                    if (list && list.length > 0) {
                        const match = list.find(i => String(i.id) === String(workorderId));
                        if (match) {
                            this.workorder_id.value.value = Number(workorderId);
                            this.onWorkorderChange(Number(workorderId));
                        }
                    }
                },
                { immediate: true }
            );
        }

        const id = this.$route.query.id;

        if (id) {
            this.$store.commit("SET_LOADING", { color: "primary" });

            this.$nextTick(() => {
                this.$store
                    .dispatch("getSaleOrderById", id)
                    .then((data) => {
                        this.isEntryMode = false;
                        let saleOrder = data;
                        this.sale_order_master_id.value.value = saleOrder.id;
                        this.sale_order_date.value.value = saleOrder.sale_order_date ? new Date(saleOrder.sale_order_date) : new Date();
                        this.shipping_date.value.value = saleOrder.shipping_date ? new Date(saleOrder.shipping_date) : new Date();
                        this.approximate_delivery_date.value.value = saleOrder.approximate_delivery_date ? new Date(saleOrder.approximate_delivery_date) : new Date();
                        this.payment_terms.value.value = saleOrder.payment_terms;
                        this.delivery_address.value.value = saleOrder.delivery_address;
                        this.ref_no.value.value = saleOrder.ref_no;
                        this.order_category.value.value = saleOrder.order_category;
                        this.workorder_id.value.value = saleOrder.workorder_id;
                        this.employee_id.value.value = saleOrder.employee_id;

                        this.discount_method.value.value = saleOrder.discount_method;
                        this.discount_value.value.value = this.discount_method.value.value == 'percent'? saleOrder.discount_value + '%' : saleOrder.discount_value;

                        this.tax_method.value.value = saleOrder.tax_method;
                        this.tax_value.value.value = this.tax_method.value.value == 'percent'? saleOrder.tax_value + '%' : saleOrder.tax_value;
                        this.taxType = saleOrder.tax_type;

                        this.vat_method.value.value = saleOrder.vat_method;
                        this.vat_value.value.value = this.vat_method.value.value == 'percent'? saleOrder.vat_value + '%' : saleOrder.vat_value;
                        this.vatType = saleOrder.vat_type;

                        this.paid.value.value = saleOrder.paid;
                        this.previous_due.value.value = saleOrder.previous_due;
                        this.due.value.value = saleOrder.due;
                        this.next_payment_date.value.value = saleOrder.next_payment_date ? new Date(saleOrder.next_payment_date) : new Date();
                        this.next_payment_amount.value.value = saleOrder.next_payment_amount;
                        this.status.value.value = saleOrder.status;
                        this.product_id.value.value = null;
                        this.customer_id.value.value = saleOrder.customer_id;
                        this.cart.value = [];

                        // Insert items one by one
                        (saleOrder.details || []).forEach((item) => {
                            this.cart.push({ 
                                product_id: item.product_id,
                                product_name: item.product?.name || "",
                                product_code: item.product.product_code,
                                qty: item.quantity,
                                unit_id: item.product.unit_id || "",
                                unit_name: item.product.unit?.name || "",
                                purchase_rate: item.purchase_rate,
                                sale_rate: item.sale_rate,
                                total: item.total,
                            });
                        });
                        this.remarks.value.value = saleOrder.remarks ? saleOrder.remarks : "";
                        this.$store.commit("UNSET_LOADING");
                    })
                    .catch((error) => {
                        this.$store.commit("UNSET_LOADING");
                        console.error("Failed to fetch rfq:", error);
                    });
            });
        } else {
            this.sale_order_master_id.value.value = "";
            this.sale_order_date.value.value = new Date();
            this.shipping_date.value.value = new Date();
            this.approximate_delivery_date.value.value = new Date();
            this.next_payment_date.value.value = new Date();
            this.next_payment_amount.value.value = 0;
            this.paid.value.value = 0;
            this.previous_due.value.value = 0;
            this.due.value.value = 0;
            this.isEntryMode = true;
        }
    },
};
</script>
